import moment from "moment"
import React, { Component } from "react"
import { Button, FormControl, Modal, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap"
import reggie from "../../../../../../../../../utilities/Reggie"
import ChecklistTypes from "../../../../../../../Types/ChecklistTypes"
import WorkCompReferenceTypes from "../../../../../../../Types/WorkCompReferenceTypes"
import ChecklistBoiler from "./IncidentChecklistConfigParams"
import "./IncidentChecklistConfig.css"
import "../../../../../../../HRSettings/HRSettings.css"


interface Props {
    toggleConfig: Function
    IncidentTypeId: number
    workCompReference: WorkCompReferenceTypes
    checklist: ChecklistTypes | any
    updateChecklist: Function
    contextUserId: number | string
    IncidentId: number
    loading: boolean
    getIncidentType: Function
}

interface State {
    reference: {
        incidentStatus: Array<{ id: number, text: string }>,
        incidentTimelineTypes: Array<{ id: number, text: string }>,
        incidentTypes: Array<{ id: number, text: string }>
    }
    item: ChecklistTypes | null
    itemCopy: ChecklistTypes | null
    confirmDelete: boolean
    editing: boolean
    adding: boolean
    linkType: string
    eventType: string
    confirmDiscard: boolean
}

class IncidentChecklistConfig extends Component<Props, State> {

    checklistsTemp: any = []
    getIndex = 0
    state = {
        reference: { incidentStatus: [], incidentTimelineTypes: [], incidentTypes: [] },
        item: null,
        itemCopy: null,
        confirmDelete: false,
        editing: false,
        adding: false,
        linkType: "DocumentLink",
        eventType: "",
        confirmDiscard: false
    }

    setEventType = (type: string) => {
        this.setState({ eventType: type })
    }

    handleChange = (event: { target: { value: string | null } }) => {
        let input = event.target.value
        if (input === "") {
            input = null
        }
        if (input && this.state.linkType === "Phone") {
            input = this.formatter(input)
        }
        let item: any = this.state.item
        item[this.state.eventType] = input
        this.setState({ item: item })
    }

    formatter = (input: string) => {
        //@ts-ignore
        let formated = reggie[`format${this.state.linkType}`](input)
        if (formated) {
            return formated
        }
        return input
    }

    validator = (input: string) => {
        //@ts-ignore
        return reggie[`validate${this.state.linkType}`](input)
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        let state: any = this.state
        for (let i = 0; i < keys.length; i++) {
            if (!keys[i].value) {
                state[keys[i].key] = !state[keys[i].key]
            } else {
                state[keys[i].key] = keys[i].value
            }
        }
        this.setState(state)
    }

    updateChecklist = (item: ChecklistTypes | null) => {
        this.setState({ adding: false, editing: false, confirmDelete: false, confirmDiscard: false })
        this.props.updateChecklist(item)
    }

    addItem = (WorkCompIncidentTypeId: number) => {
        let item: ChecklistTypes = JSON.parse(JSON.stringify(ChecklistBoiler))
        item.CreatedDateUtc = moment().format()
        item.CreatedBy = this.props.contextUserId + ""
        item.WorkCompIncidentTypeId = WorkCompIncidentTypeId
        item.IncidentId = this.props.IncidentId
        let itemCopy: ChecklistTypes = JSON.parse(JSON.stringify(item))
        this.manageState([{ key: "adding" }, { key: "item", value: item }, { key: "itemCopy", value: itemCopy }])
    }

    editItem = (item: ChecklistTypes) => {
        let temp = item
        temp.IncidentId = this.props.IncidentId
        let itemCopy: ChecklistTypes = JSON.parse(JSON.stringify(temp))
        this.manageState([{ key: "editing" }, { key: "item", value: temp }, { key: "itemCopy", value: itemCopy }])
    }

    deleteItem = (item: ChecklistTypes) => {
        let temp = item
        temp.DeletedBy = this.props.contextUserId + ""
        temp.DeletedDateUtc = moment().format()
        this.manageState([{ key: "confirmDelete" }, { key: "item", value: temp }])
    }

    isDirty = (item: ChecklistTypes, copy: ChecklistTypes) => {
        let a = JSON.stringify(item)
        let b = JSON.stringify(copy)
        if (a !== b) {
            return true
        }
        return false
    }

    shouldDiscard = (discardTypeKey: string) => {
        //@ts-ignore
        if (!this.isDirty(this.state.item, this.state.itemCopy)) {
            this.manageState([{ key: discardTypeKey }, { key: "item", value: null }])
        } else {
            this.manageState([{ key: "confirmDiscard" }])
        }
    }

    confirmDiscard = () => {
        this.setState({ adding: false, editing: false, confirmDiscard: false, item: null, itemCopy: null })
    }

    render() {

        let linkType = this.state.linkType
        let state = this.state
        let incidentType = this.props.getIncidentType()
        let checklist = this.props.checklist

        const toolTip = (text: string) => (
            <Tooltip id="uac-tool-tip">
                {text}
            </Tooltip>
        )

        return (
            <div className="BaseChecklistConfig">
                {!this.state.editing && !this.state.adding && !this.state.confirmDelete && !this.state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="ChecklistConfigModalHeader">
                            <div className="ChecklistConfigModalHeaderLeft">
                                <p>Configure <span>this</span> checklist for</p>
                                <p id="checklist-config-header-incident-type">{incidentType?.text}</p>
                            </div>
                            <div className="ChecklistConfigModalHeaderRight">
                                {!this.props.loading && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip("Add a new checklist item")}>
                                    <span className="material-icons" onClick={() => this.addItem(this.props.IncidentTypeId)}>add</span>
                                </OverlayTrigger>}
                                {this.props.loading && <Spinner id="loading-checklist-config-spinner" animation="border" />}
                            </div>
                        </div>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="BaseChecklistConfigItems">
                            {checklist && checklist.map((subItem: ChecklistTypes, subItemIndex: number) =>
                                <div className="BaseChecklistConfigChecklistItem" key={subItemIndex}>
                                    <div className="BaseChecklistConfigChecklistItemLeft">
                                        {subItem.ChecklistText && subItem.ChecklistText !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(subItem.ChecklistText)}>
                                            <p>{subItem.ChecklistText}</p>
                                        </OverlayTrigger>}
                                        {subItem.InfoText && subItem.InfoText !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(subItem.InfoText)}>
                                            <span className="material-icons">info</span>
                                        </OverlayTrigger>}
                                        {subItem.DocumentLink && subItem.DocumentLink !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(subItem.DocumentLink)}>
                                            <a href={subItem.DocumentLink || ""} target="_blank" rel="noreferrer"><span className="material-icons">description</span></a>
                                        </OverlayTrigger>}
                                        {subItem.Email && subItem.Email !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(subItem.Email)}>
                                            <a href={`mailto:${subItem.Email || ""}`} target="_blank" rel="noreferrer"><span className="material-icons">mail</span></a>
                                        </OverlayTrigger>}
                                        {subItem.Phone && subItem.Phone !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(subItem.Phone)}>
                                            <a href={`tel:${reggie.formatPhone(subItem.Phone || "")}`}><span className="material-icons">call</span></a>
                                        </OverlayTrigger>}
                                    </div>
                                    <div className="BaseChecklistConfigChecklistItemRight">
                                        <span className="material-icons" id="base-checklist-config-checklist-item-right-edit" onClick={() => this.editItem(subItem)}>edit</span>
                                        <span className="material-icons" id="base-checklist-config-checklist-item-right-delete" onClick={() => this.deleteItem(subItem)}>delete</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="ChecklistConfigModalFooter">
                            <Button variant="secondary" onClick={() => this.props.toggleConfig("config")}>Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
                {(state.adding || state.editing) && !state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="ChecklistConfigModalAddBodyConfigHeader">
                            {this.state.adding && <p>Add a Checklist item</p>}
                            {this.state.editing && <p>Edit this Checklist item</p>}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="ChecklistConfigModalAddBodyConfigItems">
                            <div className="ChecklistConfigModalAddBodyR1">
                                <FormControl onFocus={() => this.setEventType("ChecklistText")}
                                    tabIndex={-1}
                                    placeholder={"Title"}
                                    onChange={this.handleChange}
                                    //@ts-ignore
                                    value={state.item.ChecklistText || ""}
                                />
                            </div>
                            <div className="ChecklistConfigModalAddBodyR2">
                                <FormControl
                                    onFocus={() => this.setEventType("InfoText")}
                                    tabIndex={-1}
                                    as="textarea" rows={4}
                                    placeholder={"Description (optional)"}
                                    onChange={this.handleChange}
                                    //@ts-ignore
                                    value={state.item.InfoText || ""}
                                />
                            </div>
                            <div className="ChecklistConfigModalAddBodyR3">
                                <div className="ChecklistConfigModalAddBodyR3LinkTypes">
                                    {linkType !== "DocumentLink" && <span className="material-icons" onClick={() => this.manageState([{ key: "linkType", value: "DocumentLink" }, { key: "eventType", value: "DocumentLink" }])}>description</span>}
                                    {linkType === "DocumentLink" && <span className="material-icons" id="add-checklist-item-active" onClick={() => this.manageState([{ key: "linkType", value: "DocumentLink" }, { key: "eventType", value: "DocumentLink" }])}>description</span>}
                                    {linkType !== "Phone" && <span className="material-icons" onClick={() => this.manageState([{ key: "linkType", value: "Phone" }, { key: "eventType", value: "Phone" }])}>call</span>}
                                    {linkType === "Phone" && <span className="material-icons" id="add-checklist-item-active" onClick={() => this.manageState([{ key: "linkType", value: "Phone" }, { key: "eventType", value: "Phone" }])}>call</span>}
                                    {linkType !== "Email" && <span className="material-icons" onClick={() => this.manageState([{ key: "linkType", value: "Email" }, { key: "eventType", value: "Email" }])}>email</span>}
                                    {linkType === "Email" && <span className="material-icons" id="add-checklist-item-active" onClick={() => this.manageState([{ key: "linkType", value: "Email" }, { key: "eventType", value: "Email" }])}>email</span>}
                                </div>
                                {linkType === "DocumentLink" && <div className="ChecklistConfigModalAddBodyR3FormWrapper">
                                    <FormControl
                                        onFocus={() => this.setEventType("DocumentLink")}
                                        tabIndex={-1}
                                        placeholder={reggie.deCamel(linkType)}
                                        onChange={this.handleChange}
                                        //@ts-ignore
                                        value={state.item.DocumentLink || ""}
                                    />
                                </div>}
                                {linkType === "Phone" && <div className="ChecklistConfigModalAddBodyR3FormWrapper">
                                    <FormControl
                                        onFocus={() => this.setEventType("Phone")}
                                        tabIndex={-1}
                                        placeholder={reggie.deCamel(linkType)}
                                        onChange={this.handleChange}
                                        //@ts-ignore
                                        value={this.formatter(state.item.Phone || "")}
                                    />
                                </div>}
                                {linkType === "Email" && <div className="ChecklistConfigModalAddBodyR3FormWrapper">
                                    <FormControl
                                        onFocus={() => this.setEventType("Email")}
                                        tabIndex={-1}
                                        placeholder={reggie.deCamel(linkType)}
                                        onChange={this.handleChange}
                                        //@ts-ignore
                                        value={state.item.Email || ""}
                                    />
                                </div>}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="BaseChecklistModalFooter">
                            {state.adding && <Button variant="secondary" onClick={() => this.shouldDiscard("adding")}>Back</Button>}
                            {state.editing && <Button variant="secondary" onClick={() => this.shouldDiscard("editing")}>Back</Button>}
                            {/*@ts-ignore*/}
                            {state.item.ChecklistText && state.item.ChecklistText !== "" && <Button variant="primary" onClick={() => this.updateChecklist(state.item)}>Save</Button>}
                        </div>
                    </Modal.Footer>
                </Modal>}
                {!state.confirmDiscard && state.confirmDelete && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="BaseChecklistModalDeleteItemHeader">
                            Are you sure you want to delete this item?
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="BaseChecklistModalDeleteItemFooter">
                            <Button variant="secondary" onClick={() => this.manageState([{ key: "confirmDelete" }, { key: "item", value: null }])}>Back</Button>
                            <Button variant="danger" onClick={() => this.updateChecklist(state.item)}>Delete</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
                {state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="BaseChecklistModalConfirmDiscardHeader">
                            <p>Discard changes?</p>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="BaseChecklistModalConfirmDiscardFooter">
                            <Button onClick={() => this.manageState([{ key: "confirmDiscard" }])} variant="secondary">Back</Button>
                            <Button onClick={() => this.confirmDiscard()} variant="danger">Discard</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }
}

export default IncidentChecklistConfig